<div class="sk-page me-page">

  <!-- Hero-Kopf -->
  <div class="sk-hero">
    <div class="sk-hero-info">
      <h1><mat-icon class="hero-title-icon">engineering</mat-icon> Meine Einsätze</h1>
      <div class="sk-hero-sub">
        <span><mat-icon class="sk-inline-icon">today</mat-icon>{{ today | date:'EEEE, dd.MM.yyyy' }}</span>
      </div>
    </div>
    <span class="sk-hero-spacer"></span>
    <div class="sk-hero-actions">
      <button mat-raised-button class="sk-btn-light" (click)="openSpontan()">
        <mat-icon>bolt</mat-icon> Spontan-Einsatz
      </button>
      <span class="conn-chip" [class.offline]="!online">
        <mat-icon>{{ online ? 'cloud_done' : 'cloud_off' }}</mat-icon>
        {{ online ? 'Online' : 'Offline' }}
      </span>
    </div>
  </div>

  <!-- Offene Tickets Hinweis -->
  <div class="sk-card ticket-bar" *ngIf="openTicketCount > 0">
    <mat-icon class="ticket-icon">confirmation_number</mat-icon>
    <div class="ticket-text">
      <strong>{{ openTicketCount }} offene(s) Ticket(s)</strong>
      <span class="sk-muted">Neu geplante Einsätze – bitte annehmen.</span>
    </div>
  </div>

  <!-- Offline-Warteschlange -->
  <div class="sk-card sync-bar" *ngIf="pendingCount > 0">
    <mat-icon class="sync-icon">sync</mat-icon>
    <div class="sync-text">
      <strong>{{ pendingCount }} Erfassung(en) warten auf Übertragung</strong>
      <span class="sk-muted">{{ online ? 'Bereit zum Nachsenden.' : 'Werden gesendet, sobald wieder Verbindung besteht.' }}</span>
    </div>
    <span class="sk-spacer"></span>
    <button mat-raised-button color="primary" [disabled]="!online || syncing" (click)="syncNow()">
      <mat-icon>cloud_upload</mat-icon> Jetzt synchronisieren
    </button>
  </div>

  <!-- Zeitraum-Filter + Erledigte ein-/ausblenden -->
  <div class="me-filter-bar">
    <div class="sk-filter-chips">
      <button class="sk-filter-chip" [class.active]="range === 'heute'" (click)="setRange('heute')">Heute</button>
      <button class="sk-filter-chip" [class.active]="range === 'woche'" (click)="setRange('woche')">Diese Woche</button>
      <button class="sk-filter-chip" [class.active]="range === 'alle'" (click)="setRange('alle')">Alle</button>
    </div>
    <span class="me-filter-spacer"></span>
    <button class="sk-filter-chip done-chip" [class.active]="showDone" (click)="toggleShowDone()"
            *ngIf="doneCount > 0 || showDone">
      <mat-icon class="sk-inline-icon">{{ showDone ? 'visibility_off' : 'visibility' }}</mat-icon>
      Erledigte {{ showDone ? 'ausblenden' : 'anzeigen' }}<span *ngIf="doneCount > 0"> ({{ doneCount }})</span>
    </button>
  </div>

  <!-- Leerzustand -->
  <div class="sk-empty" *ngIf="!loading && dayGroups.length === 0">
    <div class="sk-empty-icon"><mat-icon>event_available</mat-icon></div>
    <p *ngIf="!(doneCount > 0 && !showDone)">Keine Einsätze in diesem Zeitraum.<br>
      <span class="sk-muted">Sobald dir ein Einsatz zugeteilt wird, erscheint er hier.</span>
    </p>
    <p *ngIf="doneCount > 0 && !showDone">Keine offenen Einsätze in diesem Zeitraum.<br>
      <span class="sk-muted">{{ doneCount }} erledigte(r) Einsatz/Einsätze ausgeblendet.</span>
    </p>
    <button mat-stroked-button *ngIf="doneCount > 0 && !showDone" (click)="toggleShowDone()">
      <mat-icon>visibility</mat-icon> Erledigte anzeigen
    </button>
  </div>

  <!-- Einsätze nach Tagen -->
  <div class="day-group" *ngFor="let g of dayGroups; trackBy: trackByDay">
    <div class="day-head">
      <mat-icon>today</mat-icon>
      <strong>{{ g.day | date:'EEEE, dd.MM.yyyy' }}</strong>
      <span class="sk-muted">{{ g.items.length }} {{ g.items.length === 1 ? 'Einsatz' : 'Einsätze' }}</span>
    </div>

    <div class="sk-card einsatz-card" [class.open-ticket]="isOpenTicket(e)"
         *ngFor="let e of g.items; trackBy: trackByEinsatz">
      <div class="ec-head">
        <div class="ec-time">
          <strong>{{ e.start | date:'HH:mm' }}</strong>
          <span class="sk-muted">– {{ e.end | date:'HH:mm' }}</span>
        </div>
        <div class="ec-title" [class.clickable]="canOpenAuftrag" (click)="openAuftrag(e)">
          <strong>{{ e.auftragTitle || e.title }}</strong>
          <span class="ec-customer sk-muted" *ngIf="e.customerName">{{ e.customerName }}</span>
        </div>
        <span class="ticket-chip" *ngIf="isOpenTicket(e)">
          <mat-icon class="sk-inline-icon">confirmation_number</mat-icon> Neu
        </span>
        <span class="work-chip" *ngIf="!isOpenTicket(e)" [attr.data-status]="e.workStatus">
          {{ workStatusLabel(e.workStatus) }}
        </span>
      </div>

      <!-- Ticket annehmen -->
      <button class="accept-btn" *ngIf="isOpenTicket(e)" (click)="accept(e)">
        <mat-icon>how_to_reg</mat-icon> Einsatz annehmen
      </button>

      <div class="ec-meta">
        <span *ngIf="e.location"><mat-icon class="sk-inline-icon">location_on</mat-icon>{{ e.location }}</span>
      </div>

      <!-- Kolonne: Vorarbeiter links, Arbeiter/Team rechts -->
      <div class="ec-crew">
        <span class="crew-lead" matTooltip="Verantwortlich">
          <mat-icon class="sk-inline-icon">engineering</mat-icon>{{ e.assignedUserName || e.assignedUserId }}
        </span>
        <span class="crew-members" *ngIf="(e.participantNames?.length || 0) + (e.workerNames?.length || 0) > 0">
          <mat-icon class="sk-inline-icon">groups</mat-icon>
          {{ (e.participantNames || []).concat(e.workerNames || []).join(', ') }}
        </span>
      </div>

      <div class="ec-captured" *ngIf="bookedHoursFor(e) > 0 || (e.materials?.length || 0) > 0">
        <span class="cap-chip hours" *ngIf="bookedHoursFor(e) > 0">
          <mat-icon class="sk-inline-icon">schedule</mat-icon>{{ bookedHoursFor(e) }} h gebucht
        </span>
        <span class="cap-chip material" *ngIf="(e.materials?.length || 0) > 0">
          <mat-icon class="sk-inline-icon">handyman</mat-icon>{{ materialSummary(e) }}
        </span>
      </div>

      <!-- Schnelle Statuswechsel -->
      <div class="ec-status-row">
        <button class="status-btn" [class.active]="e.workStatus === 'Confirmed'"
                (click)="setStatus(e, 'Confirmed')">
          <mat-icon>event_available</mat-icon> Bestätigt
        </button>
        <button class="status-btn" [class.active]="e.workStatus === 'EnRoute'"
                (click)="setStatus(e, 'EnRoute')">
          <mat-icon>directions_car</mat-icon> Unterwegs
        </button>
        <button class="status-btn" [class.active]="e.workStatus === 'Done'"
                (click)="setStatus(e, 'Done')">
          <mat-icon>task_alt</mat-icon> Erledigt
        </button>
      </div>

      <!-- Erfassung -->
      <div class="ec-actions">
        <button mat-raised-button color="primary" (click)="erfasseStunden(e)">
          <mat-icon>schedule</mat-icon> Stunden
        </button>
        <button mat-stroked-button (click)="erfasseMaterial(e)">
          <mat-icon>handyman</mat-icon> Material
        </button>
      </div>
    </div>
  </div>
</div>

<div class="sk-loading" *ngIf="loading">
  <mat-spinner diameter="42"></mat-spinner>
</div>
